import {
  PAYMENT_COLLECTION_METHOD_REQUEST,
  PAYMENT_COLLECTION_METHOD_SUCCESS,
  PAYMENT_COLLECTION_METHOD_FAIL,

  CREATE_PAYMENT_COLLECTION_METHOD_REQUEST,
  CREATE_PAYMENT_COLLECTION_METHOD_SUCCESS,
  CREATE_PAYMENT_COLLECTION_METHOD_FAIL,

  UPDATE_PAYMENT_COLLECTION_METHOD_REQUEST,
  UPDATE_PAYMENT_COLLECTION_METHOD_SUCCESS,
  UPDATE_PAYMENT_COLLECTION_METHOD_FAIL,

  DELETE_PAYMENT_COLLECTION_METHOD_REQUEST,
  DELETE_PAYMENT_COLLECTION_METHOD_SUCCESS,
  DELETE_PAYMENT_COLLECTION_METHOD_FAIL,

  CLEAR_ERROR,
} from "../../../constants/Master/OtherMasters/PaymentCollectionMethodConstant";


// create, update, delete and get all
export const getPaymentCollectionMethodsReducer = (state = { paymentCollectionMethods: [] }, action) => {
  switch (action.type) {
    case PAYMENT_COLLECTION_METHOD_REQUEST:
    case CREATE_PAYMENT_COLLECTION_METHOD_REQUEST:
    case UPDATE_PAYMENT_COLLECTION_METHOD_REQUEST:
    case DELETE_PAYMENT_COLLECTION_METHOD_REQUEST:
      return {
        ...state,
        loading: true,
        message: null,
        status: null,
        error: null,
      };

    case PAYMENT_COLLECTION_METHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentCollectionMethods: action.payload,
        message: null,
        status: null,
      };

    case CREATE_PAYMENT_COLLECTION_METHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentCollectionMethods: [...state.paymentCollectionMethods, action.payload],
        message: action.message,
        status: action.status,
      };

    case UPDATE_PAYMENT_COLLECTION_METHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentCollectionMethods: state.paymentCollectionMethods.map((item) =>
          (item.paymentLimitMethodId === action.payload.paymentLimitMethodId) ? action.payload : item
        ),
        message: action.message,
        status: action.status,
      };

    case DELETE_PAYMENT_COLLECTION_METHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentCollectionMethods: action?.payload?.isDelete ?
          state.paymentCollectionMethods.filter((item) =>
            item.paymentLimitMethodId !== action.payload.paymentLimitMethodId
          )
          :
          state.paymentCollectionMethods.map((item) =>
            (item.paymentLimitMethodId === action.payload.paymentLimitMethodId) ? action.payload : item
          ),
        message: action.message,
        status: action.status,
      };

    case PAYMENT_COLLECTION_METHOD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_PAYMENT_COLLECTION_METHOD_FAIL:
    case UPDATE_PAYMENT_COLLECTION_METHOD_FAIL:
    case DELETE_PAYMENT_COLLECTION_METHOD_FAIL:
      return {
        ...state,
        loading: false,
        message: action.message,
        status: action.status,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        status: null,
        message: null,
      };

    default:
      return state;
  }
};